import { useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import type { HTMLProps } from 'react'

interface PropsPanelKinerjaCompact extends HTMLProps<HTMLDivElement> {
  number: number | string
  rhk: string
  subRhks?: string[]
}

const PanelKinerjaCompact = ({
  number,
  rhk,
  subRhks = [],
  ...otherProps
}: PropsPanelKinerjaCompact) => {
  const [showSubRhks, setShowSubRhks] = useState(false)

  return (
    <div className="bg-white border border-gray-30 rounded p-6" {...otherProps}>
      <div className="flex items-start gap-5">
        <Text variant="heading-sm" color="primary">
          {number}.
        </Text>
        <div className="flex flex-1 justify-between items-start">
          <div className="flex flex-1 flex-col">
            <Text>{rhk}</Text>

            {!!subRhks.length && showSubRhks && (
              <div className="mt-7 flex flex-col gap-7">
                {subRhks.map((rhk, i) => (
                  <div
                    key={`${rhk}-sub-${i}`}
                    className="flex items-start gap-5"
                  >
                    <Text variant="heading-sm" color="primary">
                      {number}.{i + 1}
                    </Text>
                    <div className="flex flex-col gap-2">{rhk}</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {!!subRhks.length && (
            <Button
              variant="ghost"
              size="lg"
              onClick={() => setShowSubRhks(!showSubRhks)}
            >
              {showSubRhks ? 'Sembunyikan' : 'Selengkapnya'}
              <Icon color="informational">
                {showSubRhks ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
              </Icon>
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default PanelKinerjaCompact
